import styled from 'styled-components';
export const SectionContainer = styled.section `
  padding: 60px 20px;
  background: #ffffff;
  width: 100%;
`;
export const Container = styled.div `
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  padding: 0 20px;
`;
export const SectionHeader = styled.div `
  text-align: center;
  margin-bottom: 4rem;
`;
export const SectionTitle = styled.h2 `
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  position: relative;
  display: inline-block;
  margin: 0;
  color: #1a1a1a;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #ffd700;
    border-radius: 2px;
  }
`;
export const Form = styled.form `
  max-width: 500px;
  margin: 0 auto;
  background: #ffffff;
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.05);
  border: 1px solid #f3f4f6;
`;
export const FormTitle = styled.h3 `
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.5rem;
  color: #1a1a1a;
  font-weight: 600;
`;
export const FormGroup = styled.div `
  margin-bottom: 1.5rem;
`;
export const Label = styled.label `
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #1a1a1a;
  font-size: 0.95rem;
`;
export const Input = styled.input `
  width: 100%;
  padding: 0.875rem;
  border: 2px solid ${(props) => (props.$hasError ? '#ef4444' : '#e5e7eb')};
  border-radius: 12px;
  font-size: 1rem;
  transition: border-color 0.3s;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.$hasError ? '#ef4444' : '#ffd700')};
  }
`;
export const ErrorMessage = styled.span `
  display: block;
  color: #ef4444;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  font-weight: 500;
`;
export const Textarea = styled.textarea `
  width: 100%;
  padding: 0.875rem;
  border: 2px solid ${(props) => (props.$hasError ? '#ef4444' : '#e5e7eb')};
  border-radius: 12px;
  font-size: 1rem;
  transition: border-color 0.3s;
  font-family: inherit;
  resize: vertical;
  min-height: 120px;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.$hasError ? '#ef4444' : '#ffd700')};
  }
`;
export const Button = styled.button `
  width: 100%;
  padding: 12px 24px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s;
  border: none;
  cursor: ${(props) => (props.$isSubmitting ? 'not-allowed' : 'pointer')};
  background: ${(props) => props.$isSubmitting
    ? '#ccc'
    : 'linear-gradient(-180deg, #ffd700 0%, #e5c61c 100%)'};
  color: #1a1a1a;
  font-size: 1rem;

  &:hover {
    background: ${(props) => (props.$isSubmitting ? '#ccc' : '#fdb927')};
    transform: ${(props) => (props.$isSubmitting ? 'none' : 'translateY(-2px)')};
    box-shadow: ${(props) => props.$isSubmitting ? 'none' : '0 10px 20px rgba(253, 183, 39, 0.3)'};
  }

  &:active {
    transform: translateY(0);
  }
`;
export const SuccessMessage = styled.div `
  text-align: center;
  margin-bottom: 1rem;
  color: #10b981;
  font-weight: 600;
  font-size: 0.95rem;
`;
export const SocialIconsContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
`;
export const SocialIconLink = styled.a `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease, opacity 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px) scale(1.1);
    opacity: 0.8;
  }

  &:active {
    transform: translateY(-2px) scale(1.05);
  }
`;
export const SocialIcon = styled.img `
  width: 40px;
  height: 40px;
  display: block;
  transition: filter 0.3s ease;

  ${SocialIconLink}:hover & {
    filter: brightness(1.1);
  }
`;
